import ApiService from '@/app/common/service/ApiService';
import ISettings from '@/app/common/model/ILicenseImage';
import ILicense from '@/app/common/model/ILicense';

export default class LicenseService {
  public static async getLicense(): Promise<ILicense> {
    return ApiService.get('license');
  }

  static async getImagesSettings(): Promise<ISettings> {
    return ApiService.get('settings/logo-alt');
  }

  static async getUserSettings(): Promise<ISettings> {
    return ApiService.get('settings/registration/user');
  }

  static async getMenuLogo() {
    return ApiService.get('/settings/logo')
  }
}
